import { render } from "./ContactView.vue?vue&type=template&id=1391f245"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=1391f245&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__